<template>
  <div class="fields__field fields__field--input fields__field--date" :class="{ '-error': error && !value }">
    <div class="field__label">
      <label class="control-label bold" :for="identifier">{{ label }}</label>
    </div>
    <Datepicker
      :value="value"
      :language="de"
      :placeholder="placeholder"
      format="yyyy"
      input-class="icon-calendar-before"
      :full-month-name="true"
      :minimum-view="'year'"
      @selected="$emit('input', $event)"
      ref="datepicker">
    </Datepicker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vdp_translation_de from 'vuejs-datepicker/dist/locale/translations/de.js'
export default {
  props: ['identifier', 'placeholder', 'value', 'error', 'label'],
  data () {
    return {
      endTrigger: false,
      focus: false,
      de: vdp_translation_de
    }
  },
  components: {
    Datepicker
  },
  methods: {
    showPlaceholder: function () {
      let $wrapper = this.$refs.datepicker
      let span = $wrapper.$el.querySelectorAll('.placeholder-label')[0]
      if (this.value) {
        span.classList.add('-hide')
      } else {
        span.classList.remove('-hide')
      }
    }
  },
  watch: {
    value: function () {
      this.showPlaceholder()
    }
  },
  mounted () {
    let $wrapper = this.$refs.datepicker
    let inputWrapper = $wrapper.$el.querySelectorAll('div:first-child')
    let span = document.createElement('span')
    span.classList.add('icon-calendar-before')
    span.classList.add('placeholder-label')
    span.innerHTML= this.placeholder
    if (this.value) {
      span.classList.add('-hide')
    }
    inputWrapper[0].classList.add('field__input')
    inputWrapper[0].insertBefore(span, inputWrapper[0].firstChild)
  }
}
</script>
